import Vue from 'vue';

import App from './App.vue';
import Global from './mixins/Global.js';
import router from './router/index.js';
import store from './store/index.js';

import ApexoUI from './plugins/apexo-ui.js';
import moment from './plugins/moment.js';
import i18n from './plugins/vue-i18n.js';
import wait from './plugins/vue-wait.js';
import VueModal from './plugins/vue-modal.js';
import './plugins/axios.js';
import './plugins/sentry.js';
import './plugins/vue-api.js';
import './plugins/vuelidate.js';

import './assets/css/app.css';

window.moment = moment;

Vue.config.productionTip = false;

Vue.use(ApexoUI);
Vue.use(VueModal);

Vue.mixin(Global);

new Vue({
    i18n,
    router,
    store,
    wait,
    render: h => h(App),
}).$mount('#app');
